import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PlayerShortDto, SquadNumberDto } from "app/models";

@Component({
    selector: 'change-sqaud-number-modal',
    templateUrl: './change-suqad-number.modal.html',
    styleUrls: ['./change-suqad-number.modal.scss'],
})
export class ChangeSquadNumberModal implements OnInit {
    

    @Input() numbers: SquadNumberDto[];
    @Input() player: PlayerShortDto;
    @Input() playerPosition: string;

    freeNumbers: number[];

    formGroup: FormGroup;
   
    constructor(public activeModal: NgbActiveModal) {
    }

    ngOnInit(): void {
        this.buildFormGroup();
        this.freeNumbers = this.getFreeNumbers();
        
    }

    onSubmit() {
            var number = this.formGroup.controls.numberFormControl.value;

            if (!number || number <= 0) {
                return;
            }

            this.activeModal.close(number);
    }

    onSelectNumber(val: number) {
        this.formGroup.controls.numberFormControl.setValue(val);
    }

    private getFreeNumbers(): number[] {
        let result: number[] = [];

        for (let i = 1; i < 99; i++) {
            if (!this.numbers.find(f => f.number == i)) {
                result.push(i);

                if (result.length > 7)
                    break;
            }
        }

        return result;
    }

    private buildFormGroup() {
        this.formGroup = new FormGroup({
            numberFormControl: new FormControl(null)
        });
    }
}